import request from "./axios.setting";

export function getBaseInfo(params) {
  return request({
    url: "/web/info",
    method: "get",
    params,
  });
}

export function search(data) {
  return request({
    url: "/web/search",
    method: "POST",
    data,
  });
}

export function getProduct() {
  return request({
    url: "/web/product",
    method: "GET",
  });
}
